import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { sizes } from './style';
import Avatar, { AvatarProps } from './avatar';

interface AvatarGroupProps {
  children?: React.ReactElement<AvatarProps>[];
  className?: string;
  maxItems?: number;
  size?: keyof typeof sizes;
  /** Total number of avatars to display in the +N badge. When provided, overrides children.length for count calculation. */
  totalCount?: number;
}

const AvatarGroup = styled(({ children, className, maxItems = 2, size = 'xs', totalCount }: AvatarGroupProps) => {
  const length = totalCount ?? children?.length ?? 0;
  let renderChildren = children;
  let extra;

  if (length > maxItems) {
    renderChildren = [...(children || [])].slice(0, maxItems);
    extra = (
      <Avatar
        variant={'white-action'}
        className={'extra-avatar'}
        size={size}
        style={{ zIndex: 1200, position: 'relative', left: -2 }}
        text={`+ ${length - maxItems}`}
      />
    );
  }

  return (
    <div className={classNames('box-avatar-group', className)}>
      {renderChildren &&
        React.Children.map(renderChildren, (child, index) => React.cloneElement(child, { size, key: index }))}
      {extra}
    </div>
  );
})<AvatarGroupProps>`
  display: flex;

  > *:not(:first-child) {
    position: relative;
    margin-left: -7px;
  }
`;

export default AvatarGroup;
